import useResponsiveDesign from 'hooks/useResponsiveDesign'

import Styles from './ContactInformation.module.scss'

export const ContactInformation = () => {
  const email = 'support@blaze.ai'
  const href = `mailto:${email}`
  const { isMobile } = useResponsiveDesign()

  return (
    <div className={Styles.container}>
      <p className={Styles.title}>Questions?</p>
      <p className={Styles.description}>
        Contact us anytime at <a href={href}>{email}</a>
        {!isMobile && ' or hit the question mark at the bottom right corner and chat to us via Intercom.'}
      </p>
    </div>
  )
}
